import { yup } from '@jbc-year-end-adj/common/yup';
import { Profile } from './query';
import { Question, QuestionGroup } from '@jbc-year-end-adj/2024/features/questions/types';

export type Schema = {
  hasLifeInsurance: boolean;
  hasEarthquakeInsurance: boolean;
  hasSocialInsurance: boolean;
  hasPremium: boolean;
  hasHousingLoan: boolean;
};

export const schema = yup.object({
  hasLifeInsurance: yup.bool().required(),
  hasEarthquakeInsurance: yup.bool().required(),
  hasSocialInsurance: yup.bool().required(),
  hasPremium: yup.bool().required(),
  hasHousingLoan: yup.bool().required()
});

export const buildDefaultValues = (profile: Profile, group: QuestionGroup | undefined, question: Question): Schema => {
  if (question.status === 'answered') {
    return {
      hasLifeInsurance: getRequestQuestionStatus('life_insurances', group) !== 'skipped',
      hasEarthquakeInsurance: getRequestQuestionStatus('earthquake_insurances', group) !== 'skipped',
      hasSocialInsurance: getRequestQuestionStatus('social_insurances', group) !== 'skipped',
      hasPremium: getRequestQuestionStatus('premium', group) !== 'skipped',
      hasHousingLoan: getRequestQuestionStatus('housing_loan', group) !== 'skipped'
    };
  } else {
    const hasGeneralLifeInsurances = profile.generalLifeInsurances.length > 0;
    const hasNursingMedicalInsurances = profile.nursingMedicalInsurances.length > 0;
    const hasIndividualAnnuityInsurances = profile.individualAnnuityInsurances.length > 0;

    return {
      hasLifeInsurance: hasGeneralLifeInsurances || hasNursingMedicalInsurances || hasIndividualAnnuityInsurances,
      hasEarthquakeInsurance: profile.earthquakeInsurances.length > 0,
      hasSocialInsurance: profile.socialInsurances.length > 0,
      hasPremium: !!profile.premium,
      hasHousingLoan: !!profile.housingLoan
    };
  }
};

type questionCode = 'life_insurances' | 'earthquake_insurances' | 'social_insurances' | 'premium' | 'housing_loan';

const getRequestQuestionStatus = (code: questionCode, group: QuestionGroup | undefined) => {
  const questions = group?.questions;
  return questions?.find(q => q.code === code)?.requestQuestion?.status;
};
